<template>
  <div class="pa-character-icon" :class="additionalClass" @click.prevent="handleClickIcon" v-if="hasCharaterData">
    <template v-if="hasPictureThumbnail">
      <picture v-if="(pictureURL !== null)">
        <source :srcset="pictureURL | mutatePathPngToWebp" type="image/webp">
        <img :src="pictureURL" />
      </picture>
    </template>
    <template v-else>
      <span class="as-text" v-if="(thumbnailString !== null)">{{thumbnailString}}</span>
    </template>
  </div>
</template>

<script>
export default {
  props : {
    character : {
      default: () => {
        return {
          thumbnail_type  : 'string',
          displayname     : '異',
        }
      },
    },

    clickable : {
      default: true
    }
  },

  data(){
    return {
      pictureURL      : null,
      thumbnailString : null,

      additionalClass : {
        'is-clickable'  : false
      }
    };
  },

  computed  : {
    hasCharaterData(){
      if(typeof this.character === 'undefined') return false;

      if(this.character !== null){
        return true;
      }else{
        return false;
      }
    },

    hasPictureThumbnail(){
      if(this.character.thumbnail_type === 'picture'){
        return true;
      }else{
        return false;
      }
    }
  },

  watch : {
    character : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(!this.hasPictureThumbnail){
          this.thumbnailString = this.character.displayname[0];
        }else{
          this.pictureURL = this.character.thumbnail.url;
        }
      },
      immediate: true,
      deep: true
    },

    hasPictureThumbnail : {
      handler(value){
        if(value !== true) return;

        this.pictureURL = this.character.thumbnail.url;
      },
      immediate: true
    },

    clickable : {
      handler(value){
        if(typeof value === 'undefined') return;

        this.additionalClass['is-clickable'] = value;
      },
      immediate: true
    }
  },

  methods : {
    handleClickIcon(){
      if(this.clickable === false) return;

      this.$store.dispatch({
        type        : 'character/updateDetailModalIsOpen',
        value       : true,
        characterId : this.character.id
      });
    }
  },
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-character-icon{
  width:100%;
  height:100%;
  border-radius: 50%;
  margin:0 auto;
  padding:0;

  text-align: center;
  line-height: 100%;
  font-size:1.5rem;
  user-select: none;

  // &.has-border{
  //   border-width: 4px;
  //   border-style: solid;
  //   border-color:#0d7c77;
  // }

  // &.border-blue{
  //   border-color:#0d7c77;
  // }

  img{
    border-radius: 50%;
  }

  @media screen and (min-width: $desktop) {
    width:75px;
    height:75px;
    line-height: 75px;
    font-size:2rem;
  }

  &.is-clickable{
    cursor: pointer;
  }
}
</style>